import { render, staticRenderFns } from "./supplierEnterpriseInfo.vue?vue&type=template&id=21e3b965&scoped=true"
import script from "./supplierEnterpriseInfo.vue?vue&type=script&lang=js"
export * from "./supplierEnterpriseInfo.vue?vue&type=script&lang=js"
import style0 from "./supplierEnterpriseInfo.vue?vue&type=style&index=0&id=21e3b965&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3b965",
  null
  
)

export default component.exports